export default __webpack_public_path__ + "static/media/Spectral-MediumItalic.54991507.ttf";